import { render, staticRenderFns } from "./ModalGalery.vue?vue&type=template&id=0016277a&scoped=true"
import script from "./ModalGalery.vue?vue&type=script&lang=js"
export * from "./ModalGalery.vue?vue&type=script&lang=js"
import style0 from "./ModalGalery.vue?vue&type=style&index=0&id=0016277a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0016277a",
  null
  
)

/* custom blocks */
import block0 from "./ModalGalery.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports